export default "__VITE_ASSET__SPnjC4Ei__"